import { useEffect } from 'react';

/**
 * EnvironmentIndicator
 * 
 * Componente que exibe um indicador visual quando o sistema está rodando
 * em ambiente de STAGING/HOMOLOGAÇÃO ou DEVELOPMENT.
 * 
 * - Badge fixo no canto inferior direito
 * - Barra colorida no topo da tela (laranja para staging, azul para development)
 * - Invisível em produção
 */
export function EnvironmentIndicator() {
  const environment = import.meta.env.VITE_APP_ENV;
  const isStaging = environment === 'staging';
  const isDevelopment = environment === 'development';

  // Debug: verificar valor da variável
  console.log('═══════════════════════════════════════════');
  console.log('[EnvironmentIndicator] VITE_APP_ENV:', environment);
  console.log('[EnvironmentIndicator] isStaging:', isStaging);
  console.log('[EnvironmentIndicator] isDevelopment:', isDevelopment);
  console.log('═══════════════════════════════════════════');

  useEffect(() => {
    if (isStaging) {
      // Adiciona barra laranja no topo do body
      document.body.style.borderTop = '3px solid #f59e0b'; // amber-500
    } else if (isDevelopment) {
      // Adiciona barra azul no topo do body
      document.body.style.borderTop = '3px solid #3b82f6'; // blue-500
    }

    return () => {
      // Cleanup: remove a barra ao desmontar
      document.body.style.borderTop = '';
    };
  }, [isStaging, isDevelopment]);

  // Não renderiza nada em produção
  if (!isStaging && !isDevelopment) {
    return null;
  }

  return (
    <>
      {/* Badge fixo no canto inferior direito */}
      <div
        className="fixed bottom-4 right-4 z-[9999] pointer-events-none"
        role="status"
        aria-live="polite"
      >
        <div className={`
          ${isStaging ? 'bg-amber-500' : 'bg-blue-500'}
          text-black font-bold px-4 py-2 rounded-lg shadow-lg opacity-90 
          flex items-center gap-2 animate-pulse
        `}>
          <span className="text-xl">{isStaging ? '⚠️' : '🔧'}</span>
          <span className="text-sm uppercase tracking-wide">
            {isStaging ? 'Ambiente de Testes' : 'Ambiente de Desenvolvimento'}
          </span>
        </div>
      </div>

      {/* Informação adicional para leitores de tela */}
      <div className="sr-only">
        Você está no ambiente de {isStaging ? 'homologação' : 'desenvolvimento'}. Este não é o sistema de produção.
      </div>
    </>
  );
}
